import { FileIcon } from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import type { FC } from "react";
import { Link } from "react-router-dom";

interface FileProps {
  executionId: string;
  path: string;
  file: string;
}

const File: FC<FileProps> = ({ executionId, path, file }) => {
  if (file.endsWith(".trace") || file.endsWith(".log")) {
    return (
      <Link
        to={`view/${[path, file].filter(Boolean).join("/")}`}
        target="blank"
        className="flex flex-row gap-2 items-center ml-1"
      >
        <FileIcon file={file} />
        {file}
      </Link>
    );
  }

  return (
    <a
      href={api.artifactURL(
        executionId,
        [path, file].filter(Boolean).join("/"),
      )}
      download={file}
    >
      <div className="flex flex-row gap-2 items-center ml-1">
        <FileIcon file={file} />
        {file}
      </div>
    </a>
  );
};

export default File;
